export default "__VITE_ASSET__QOD9H1Lt__"